module.exports = __webpack_public_path__ + "static/media/team.f51d15dd.svg";